import { ScrollTrigger } from "gsap/ScrollTrigger";

window.addEventListener('load', () => {
    function toggleEmptyResults(currentList) {
        let linksTotal = currentList.querySelectorAll('.js-link').length;
        let linksHidden = currentList.querySelectorAll('.js-link.hide').length;
        let emptyResult = currentList.nextElementSibling;

        console.log(linksTotal, linksHidden)
    
        linksTotal === linksHidden ?
          (currentList.classList.add("hide"), emptyResult.classList.remove("hide")) :
          (currentList.classList.remove("hide"), emptyResult.classList.add("hide"));
    }

    function initSearch() {
        const searchInput = document.querySelector('.js-search-sitemap');

        searchInput.addEventListener('keyup', function() {
            let searchValue = this.value.toLowerCase();
            let searchParent = searchInput.parentElement;
            let listLinksBlock = searchParent.nextElementSibling;
            let listLinks = listLinksBlock.querySelector('.js-list-link');
            let links = listLinks.querySelectorAll('.js-link a')

            links.forEach(link => {
                let linkSpan = link.querySelector('span');
                let linkText = linkSpan.textContent.toLowerCase();

                if (linkText.indexOf(searchValue) === -1) {
                    link.classList.add('hide')
                    link.parentElement.classList.add('hide')
                    toggleEmptyResults(listLinks)
                    ScrollTrigger.refresh();
                }else {
                    link.classList.remove('hide')
                    link.parentElement.classList.remove('hide')
                    toggleEmptyResults(listLinks)
                    ScrollTrigger.refresh();
                }
            })
        })
    }

    initSearch();
})